import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import { useEffect, useRef, useState } from "react";
import logoVitaleauColor from "../../assets/images/Vital'_Eau-Logo-RVB-Violet.svg";
import logoVitaleau from "../../assets/images/Vital'_Eau-Logo-RVB.svg";

export const Header = ({ onClick }) => {
    const scrollPositionRef = useRef(0);
    const [scrollPosition, setScrollPosition] = useState(0);
    const headerRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [dropDownActivity, setDropDownActivity] = useState(false);

    const handleHamburgerClick = () => {
        setIsOpen(!isOpen);
    };

    const toggleDropDownActivity = () => {
        setDropDownActivity(!dropDownActivity);
    };

    const handleScroll = () => {
        setScrollPosition(document.body.scrollTop);

        const currentPosition = window.pageYOffset;

        // Mettre à jour scrollPositionRef avec la nouvelle valeur de currentPosition
        scrollPositionRef.current = currentPosition;
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll, true);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <header className={`navbar ${scrollPosition === 0 ? "" : "sticky"} ${isOpen ? "navbar-open" : ""}`} ref={headerRef} id="sticky-header">
                <Container maxWidth="xl" className="storybook-header">
                    <Grid container alignItems={"center"}>
                        <Grid item lg={2} md={2} sm={3} xs={4}>
                            <a href="/" alt="Accueil Vital'Eau" className="logo-vitaleau">
                                {scrollPosition === 0 ? (
                                    <>
                                        {isOpen ? (
                                            <img src={logoVitaleauColor} alt="Logo Vital'Eau" width={160} height={90} />
                                        ) : (
                                            <img src={logoVitaleau} alt="Logo Vital'Eau" width={160} height={90} />
                                        )}
                                    </>
                                ) : (
                                    <img src={logoVitaleauColor} alt="Logo Vital'Eau" width={160} height={90} />
                                )}
                            </a>
                        </Grid>
                        <Grid item lg={10} md={10} sm={9} xs={8} className="vitaleau-container-nav">
                            <nav className={`vitaleau-container-inner-nav nav-links ${isOpen ? "open" : ""}`}>
                                <ul className={`fade ${isOpen ? "fade" : ""}`}>
                                    <li className="li-dropdown-nav-menu">
                                        <a href="/activites" className="dropdown-nav-menu" onMouseEnter={() => toggleDropDownActivity()}>
                                            Nos activités
                                            <KeyboardArrowDownIcon
                                                style={{
                                                    transform: dropDownActivity ? "rotate(180deg)" : "",
                                                }}
                                            />
                                        </a>
                                        <ul
                                            className="submenu"
                                            style={{
                                                display: dropDownActivity ? "" : "none",
                                            }}
                                            onMouseEnter={() => setDropDownActivity(true)}
                                            onMouseLeave={() => setDropDownActivity(false)}
                                        >
                                            <li>
                                                <a href="/activites/bebes-nageurs">Bébés</a>
                                                <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1.28027 6.86612L17.2803 6.86612M17.2803 6.86612L11.2803 12.8661M17.2803 6.86612L11.2803 0.866119"
                                                        stroke="#FFD31C"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </li>
                                            <li>
                                                <a href="/activites/enfants">Enfants</a>
                                                <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1.28027 6.86612L17.2803 6.86612M17.2803 6.86612L11.2803 12.8661M17.2803 6.86612L11.2803 0.866119"
                                                        stroke="#FFD31C"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </li>
                                            <li>
                                                <a href="/activites/adultes">Adultes</a>
                                                <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1.28027 6.86612L17.2803 6.86612M17.2803 6.86612L11.2803 12.8661M17.2803 6.86612L11.2803 0.866119"
                                                        stroke="#FFD31C"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </li>
                                            <li>
                                                <a href="/activites/seniors">Séniors</a>
                                                <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M1.28027 6.86612L17.2803 6.86612M17.2803 6.86612L11.2803 12.8661M17.2803 6.86612L11.2803 0.866119"
                                                        stroke="#FFD31C"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="li-dropdown-nav-menu">
                                        <Link href="/planning" title="Planning">
                                            Plannings
                                        </Link>
                                    </li>
                                    <li className="li-dropdown-nav-menu">
                                        <Link href="/tarifs" title="Tarifs">
                                            Tarifs
                                        </Link>
                                    </li>
                                    <li className="li-dropdown-nav-menu">
                                        <Link href="/inscription" title="Inscription">
                                            S'inscrire
                                        </Link>
                                    </li>
                                    <li className="li-dropdown-nav-menu">
                                        <Link href="/anniversaire" title="Anniversaire">
                                            Anniversaire
                                        </Link>
                                    </li>
                                    <li className="li-dropdown-nav-menu">
                                        <Link href="/contact" title="Contact">
                                            Contact
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                            <button className={`hamburger ${isOpen ? "toggle" : ""}`} onClick={handleHamburgerClick}>
                                <div className="line1"></div>
                                <div className="line2"></div>
                                <div className="line3"></div>
                            </button>
                        </Grid>
                    </Grid>
                </Container>
            </header>
        </>
    );
};
